export const PackageCodesPPlus = {
    ESSENTIAL: 'CBS_ALL_ACCESS_LOW_COST_PACKAGE',
    LC: 'CBS_ALL_ACCESS_PACKAGE',
    PREMIUM: 'CBS_ALL_ACCESS_AD_FREE_PACKAGE',
} as const;

export const PackageCodesPPlusIntl = {
    ADS: 'CBS_ALL_ACCESS_LOW_COST_PACKAGE',
    ADS_MVPD: 'PPLUS_INTL_MVPD_ADS_PACKAGE',
    MOBILE_ONLY: 'PPLUS_INTL_MOBILE_ONLY_PACKAGE',
    MOBILE_ONLY_MVPD: 'PPLUS_INTL_MVPD_MOBILEONLY_PACKAGE',
    PREMIUM: 'PPLUS_INTL_PREMIUM_PACKAGE',
    PREMIUM_MVPD: 'PPLUS_INTL_MVPD_PREMIUM_PACKAGE',
    STANDARD: 'CBS_ALL_ACCESS_AD_FREE_PACKAGE',
    STANDARD_MVPD: 'PPLUS_INTL_MVPD_PACKAGE',
} as const;

export const PackageSource = {
    RECURLY: 'recurly',
} as const;
